// src/App.jsx
import "./i18n";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

import Dashboard from "./pages/Dashboard";
import VerifyEmail from "./pages/VerifyEmail";
import AuthPage from "./pages/AuthPage";
import i18n from "./i18n";
import Verify from "./pages/Verify";
import { AlertProvider } from "./components/CustomAlert";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ContactPage from "./pages/ContactPage";
import AuthAction from "./pages/AuthAction";
import Menu from "./pages/Menu";
import StoreCreateMember from "./pages/StoreCreateMember";

// ======================
//  试营业弹窗组件
// ======================
function SoftOpeningPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(function () {
    if (typeof window === "undefined") {
      return;
    }

    // ✅ 新版本的 key，避免和以前 v1 冲突
    var storageKey = "riceroma_soft_opening_popup_v2";

    // 今天的字符串，例如 "2026-1-14"
    var today = new Date();
    var todayKey =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    // 如果今天已经弹过，就不再弹
    try {
      var stored = window.localStorage.getItem(storageKey);
      if (stored === todayKey) {
        return;
      }
    } catch (e) {
      // 读取失败就当没弹过
    }

    // 延迟 0.8 秒再弹出
    var timer = window.setTimeout(function () {
      setVisible(true);
    }, 800);

    return function () {
      window.clearTimeout(timer);
    };
  }, []);

  function handleClose() {
    setVisible(false);

    // 记录“今天已经关闭过弹窗”
    if (typeof window !== "undefined") {
      try {
        var today = new Date();
        var todayKey =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();

        window.localStorage.setItem(
          "riceroma_soft_opening_popup_v2",
          todayKey
        );
      } catch (e) {
        // ignore
      }
    }
  }

  function handleViewMembership() {
    if (typeof window !== "undefined") {
      window.location.href = "/dashboard";
    }
  }

  if (!visible) {
    return null;
  }

  var overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "16px",
  };

  var containerStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    maxWidth: "520px",
    width: "100%",
    padding: "24px 20px 20px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
    position: "relative",
  };

  var titleStyle = {
    fontSize: "20px",
    fontWeight: 700,
    textAlign: "center",
    color: "#ff7a00",
    marginBottom: "16px",
  };

  var textStyle = {
    fontSize: "15px",
    lineHeight: 1.8,
    color: "#333333",
  };

  var hrStyle = {
    border: "none",
    borderTop: "1px solid #eeeeee",
    margin: "12px 0",
  };

  var closeBtnStyle = {
    position: "absolute",
    top: "10px",
    right: "12px",
    fontSize: "20px",
    lineHeight: 1,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    color: "#999999",
  };

  var primaryBtnStyle = {
    marginTop: "18px",
    width: "100%",
    borderRadius: "999px",
    border: "none",
    padding: "12px 16px",
    fontSize: "16px",
    fontWeight: 600,
    backgroundColor: "#ff7a00",
    color: "#ffffff",
    cursor: "pointer",
  };

  var linkBtnStyle = {
    marginTop: "12px",
    textAlign: "center",
    fontSize: "14px",
    color: "#ff7a00",
    textDecoration: "underline",
    cursor: "pointer",
  };

  function stopProp(e) {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
  }

  return (
    <div style={overlayStyle} onClick={handleClose}>
      <div style={containerStyle} onClick={stopProp}>
        <button style={closeBtnStyle} onClick={handleClose} aria-label="Close">
          ×
        </button>

        <div style={titleStyle}>新店开业，免费兑换饭美丽招牌饭</div>

        <div style={textStyle}>
          <p>
            新店开业，所有{" "}
            <strong>月卡会员</strong> 在饭美丽 Riceroma 门店（5418 Yonge St.），
            <strong>可以免费任选一份饭美丽招牌饭</strong>；所有{" "}
            <strong>年卡会员，</strong>
            <strong>可以在未来一年，每月免费任选一份招牌饭</strong>。
          </p>
          <p>如有疑问，请联系 support@riceroma.ca 或向店员咨询。</p>

          <hr style={hrStyle} />

          <p
            style={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#ff7a00",
              marginTop: "4px",
              marginBottom: "4px",
            }}
          >
            Grand Opening: Members Enjoy a Free Riceroma Signature Meal
          </p>

          <p
            style={{
              fontSize: "16px",
              color: "#888888",
              marginTop: "8px",
              lineHeight: 1.6,
            }}
          >
            To celebrate our grand opening, all <strong>monthly members </strong>
            can redeem one Riceroma Signature Meal of their choice at the
            Riceroma store (5418 Yonge St.). All <strong>yearly members</strong>{" "}
            can redeem one Riceroma Signature Meal of their choice every month
            for the next year.
          </p>
        </div>

        <div style={linkBtnStyle} onClick={handleViewMembership}>
          查看会员信息 / View membership
        </div>

        <button style={primaryBtnStyle} onClick={handleClose}>
          我知道了 / Got it
        </button>
      </div>
    </div>
  );
}

// ======================
// 路由（带动画）
// ======================
function AnimatedRoutes({ isAuthed, isVerified, userData, i18n }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* 根路由：没登录进登录页 已登录没验证进 /verify-email 否则进 Dashboard */}
        <Route
          path="/"
          element={
            !isAuthed ? (
              <AuthPage />
            ) : !isVerified ? (
              <Navigate to="/verify-email" replace />
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />

        {/* 登录页直达 */}
        <Route path="/login" element={<AuthPage />} />

        {/* 忘记密码：发送重置邮件 */}
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Firebase 通用回调 */}
        <Route path="/auth-action" element={<AuthAction />} />
        <Route path="/__/auth/action" element={<AuthAction />} />

        {/* 邮箱验证页 */}
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* 重置密码页：通过邮件链接跳转过来 */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Dashboard：必须登录且验证 */}
        <Route
          path="/dashboard"
          element={
            isAuthed ? (
              isVerified ? (
                <Dashboard
                  loading={!userData}
                  handleLogout={function () {
                    auth.signOut();
                  }}
                  switchLanguage={function (lang) {
                    i18n.changeLanguage(lang);
                  }}
                  i18n={i18n}
                />
              ) : (
                <Navigate to="/verify-email" replace />
              )
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 会员二维码验证页 */}
        <Route path="/verify" element={<Verify />} />

        {/* About 品牌故事页 */}
        <Route path="/about" element={<About />} />

        {/* 隐私与条款 */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        {/* 联系页 */}
        <Route path="/contact" element={<ContactPage />} />

        {/* 门店现场生成会员 */}
        <Route path="/store-member" element={<StoreCreateMember />} />

        {/* 短链接：/st 直接跳到 /store-member */}
        <Route
          path="/st"
          element={<Navigate to="/store-member" replace />}
        />

        {/* ✅ 新增菜单路由 */}
        <Route path="/menu" element={<Menu />} />

        {/* 兜底路由 一定放最后 */}
        <Route
          path="*"
          element={<Navigate to={isAuthed ? "/dashboard" : "/"} replace />}
        />

      </Routes>
    </AnimatePresence>
  );
}

// ======================
// App 入口
// ======================
function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [membership, setMembership] = useState(null); // 预留给后面用
  const [loading, setLoading] = useState(true);

  // 监听登录状态
  useEffect(function () {
    const unsubscribe = onAuthStateChanged(auth, async function (currentUser) {
      try {
        if (currentUser) {
          await currentUser.reload();
        }
      } catch (e) {
        // ignore
      } finally {
        setUser(auth.currentUser || null);
        setLoading(false);
      }
    });

    return function () {
      unsubscribe();
    };
  }, []);

  // 读 Firestore 用户信息
  useEffect(
    function () {
      if (!user) {
        setUserData(null);
        setMembership(null);
        return;
      }

      // users 集合
      getDoc(doc(db, "users", user.uid)).then(function (docSnap) {
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          setUserData(null);
        }
      });

      // memberships 集合
      getDoc(doc(db, "memberships", user.uid)).then(function (docSnap) {
        if (docSnap.exists()) {
          setMembership(docSnap.data());
        } else {
          setMembership(null);
        }
      });
    },
    [user]
  );

  if (loading) {
    return <div>加载中...</div>;
  }

  const isAuthed = !!user;
  const isVerified = !!(user && user.emailVerified);

  return (
    <AlertProvider>
      <Router>
        {/* 试营业提示弹窗（全站共用） */}
        <SoftOpeningPopup />

        <AnimatedRoutes
          isAuthed={isAuthed}
          isVerified={isVerified}
          userData={userData}
          i18n={i18n}
        />
      </Router>
    </AlertProvider>
  );
}

export default App;
